<template>
  <div class="modal fade" :id="`editRegionModal` + regionData.id" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">編輯{{ regionData.bx_alias }}區域</h5>
        </div>
        <div class="modal-body">
          <div class="form-group row">
            <label class="col-sm-5 col-form-label" for="alias">修改區域別名：</label>
            <div class="col-sm-7">
              <input class="form-control" type="text" id="alias" v-model="alias" :placeholder="regionData.bx_alias">
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">取消</button>
          <button type="button" class="btn btn-success" @click="editRegion(regionData.id)" data-dismiss="modal">
            送出
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      alias: '',
      base_url,
    }
  },
  methods: {
    editRegion(region_id) {
      if (this.alias) {
        axios.patch(base_url + "/api/regions/" + region_id, {
          "bx_alias": this.alias
        }).then((response) => {
          this.alias = '';
          this.$emit('update-region')
        }).catch(function (error) { console.error(error.toJSON()); });
      }
    },
  },
  props: ['regionData'],
}
</script>
